import { ROLES_NAME } from "@/_old/enums/roles-name";
import { useAuth } from "@/core/components/auth/store/auth";
import { useTranslation } from "react-i18next";
import { getRoleName } from "@/core/utils/role";

function SidebarUserProfile({ hideText = false }: { hideText?: boolean }) {
  const { userInfo } = useAuth();

  const [translate] = useTranslation(["core"]);

  return (
    <div className="flex items-center gap-3">
      <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-500 text-sm font-bold text-primary">
        {userInfo.user.first_name.charAt(0)}
        {userInfo.user.last_name.charAt(0)}
      </div>
      {!hideText && (
        <div>
          <div className="font-semibold text-primary text-sm">
            {userInfo.user.first_name} {userInfo.user.last_name}
          </div>
          <div className="text-xs text-muted-foreground">
            {translate(
              `${getRoleName(userInfo.profile.role[0] as ROLES_NAME)}`,
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default SidebarUserProfile;
